import { render, staticRenderFns } from "./GenericAdminList.vue?vue&type=template&id=e6e34818&scoped=true&"
import script from "./GenericAdminList.vue?vue&type=script&lang=js&"
export * from "./GenericAdminList.vue?vue&type=script&lang=js&"
import style0 from "./GenericAdminList.vue?vue&type=style&index=0&id=e6e34818&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e34818",
  null
  
)

export default component.exports